import React, { useEffect, useState } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import { TextField, Chip, Box, Autocomplete } from "@mui/material";
import { useDispatch } from "react-redux";
// import { fetchPermissions } from "../../../store/slices/aclSlice.js";
import {
    getAllRoles,
    getPermissions,
    createPermissions,
    deletePermissions
} from "../../../store/slices/usersSlice";
import { useSelector } from "react-redux";

const EditRoleModal = ({ isOpen, toggle, role, onSave }) => {
  // const [permissions, setPermissions] = useState(role?.RolePermisions?.filter((item)=>item?.Permissions?.permission_value) || []);
  const [permissions, setPermissions] = useState(
  role?.RolePermissions?.map(item => item?.Permissions?.permission_value).filter(Boolean) || []
);
  console.log(permissions,"Edit modal");
  
  const [inputValue, setInputValue] = useState("");
  // const permissionOptions = useSelector((state) => state.acl.permissions);
      const permissionOptions = useSelector((state) => state.users.permissionsData);

  const dispatch = useDispatch()
  useEffect(() => {
  dispatch(getPermissions())
  }, [isOpen]);


  const handleAddPermission = (newPermissionValue) => {
    if (newPermissionValue && !permissions?.includes(newPermissionValue)) {
      setPermissions([...permissions, newPermissionValue]);
    }
  };

  const handleRemovePermission = (permissionToRemove) => {
    setPermissions(permissions?.filter((perm) => perm !== permissionToRemove));
  };

  const handleSave = () => {
    onSave({ ...role, permissions });
    // console.log()
  };


  useEffect(() => {
    setPermissions(role?.RolePermissions?.map(item => item?.Permissions?.permission_value).filter(Boolean) || []);
  }, [role]);

  return (
    <Modal isOpen={isOpen} toggle={toggle} size="lg">
      <ModalHeader toggle={toggle}>{`Edit Permissions for ${role.role_value}`}</ModalHeader>
      <ModalBody>
        <Box display="flex" flexDirection="column" gap={3}>
          <Box>
            <strong>Permissions:</strong>
            <Box
              display="flex"
              flexWrap="wrap"
              gap={1}
              mt={1}
              p={2}
              border="1px solid #dee2e6"
              borderRadius="4px"
              minHeight="80px"
              alignItems="center"
            >
              {permissions?.length > 0 ? (
                permissions?.map((permissionValue) => (
                  <Chip
                    key={permissionValue}
                    label={permissionValue}
                    onDelete={() => handleRemovePermission(permissionValue)}
                    color="primary"
                  />
                ))
              ) : (
                <span style={{ color: "#6c757d" }}>No permissions assigned.</span>
              )}
            </Box>
          </Box>
          <Autocomplete
            options={permissionOptions || []}
            getOptionLabel={(option) => option.permission_value || ""}
            isOptionEqualToValue={(option, value) => option.permission_value === value.permission_value}
            value={null} 
            onInputChange={(event, newInputValue) => {
              setInputValue(newInputValue);
            }}
            onChange={(event, newValue) => {
              if (newValue) {
                handleAddPermission(newValue.permission_value);
              }
              setInputValue("");
            }}
            inputValue={inputValue}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Add Permissions"
                placeholder="Type to search permissions"
                fullWidth
              />
            )}
          />
        </Box>
      </ModalBody>
      <ModalFooter>
        <Button color="primary" onClick={handleSave}>
          Save
        </Button>{" "}
        <Button color="secondary" onClick={toggle}>
          Cancel
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default EditRoleModal;
